import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { hideTransferEmailBox } from "./coeSlice";
import { env } from "../../environment";
import { XIcon } from "@heroicons/react/solid";

export default function COETransferEmailBox() {
  const transferEmailBox = useSelector((state) => state.coe.transferEmailBox);

  const [fromEmail, setFromEmail] = useState("");
  const [confirmFromEmail, setConfirmFromEmail] = useState("");

  const [toEmail, setToEmail] = useState("");
  const [confirmToEmail, setConfirmToEmail] = useState("");

  const [success, setSuccess] = useState(false);
  const [emailFailure, setEmailFailure] = useState(false);

  const dispatch = useDispatch();

  if (transferEmailBox == true) {
    document.body.style.overflow = "hidden";
  }
  function register() {
    if (
      fromEmail == confirmFromEmail &&
      fromEmail != "" &&
      validateEmail(fromEmail) &&
      toEmail == confirmToEmail &&
      toEmail != "" &&
      validateEmail(toEmail)
    ) {
      let fetchURL =
        env +
        "inmateSubscribe.do?method=transfer&emailTo=" +
        toEmail +
        "&confirmEmailTo=" +
        confirmToEmail +
        "&emailFrom=" +
        fromEmail +
        "&confirmEmailFrom=" +
        confirmFromEmail;

      console.log(fetchURL);
      fetch(fetchURL)
        .then((response) => response.json())
        .then((data) => {
          if (data.type == "success") {
            hideTransferError();
            setSuccess(true);
            dispatch(hideTransferEmailBox());
          }
        });
    } else if (
      (validateEmail(fromEmail) == false && fromEmail != "") ||
      (validateEmail(toEmail) == false && toEmail != "")
    ) {
      document.getElementById("transferError").innerHTML =
        "Email must be in a valid format.";
    } else if (
      fromEmail == "" &&
      confirmFromEmail == "" &&
      toEmail == "" &&
      confirmToEmail == ""
    ) {
      document.getElementById("transferError").innerHTML =
        "Email is required. (255 characters max)";
    } else if (confirmFromEmail == "" || confirmToEmail == "") {
      document.getElementById("transferError").innerHTML =
        "Email Re-entry is required. (255 characters max)";
    } else if (fromEmail != confirmFromEmail) {
      document.getElementById("transferError").innerHTML =
        "Email Addresses (From) must match";
    } else if (toEmail != confirmToEmail) {
      document.getElementById("transferError").innerHTML =
        "Email Addresses (To) must match";
    }
  }
  function validateEmail(email) {
    if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
      return true;
    }
    return false;
  }
  function hideTransferError() {
    document.getElementById("transferError").innerHTML = "";
  }

  function exit() {
    dispatch(hideTransferEmailBox());
    setSuccess(false);
    setEmailFailure(false);
    setFromEmail("");
    setConfirmFromEmail("");
    setToEmail("");
    setConfirmToEmail("");
    hideTransferError();
    document.body.style.overflow = "auto";
  }
  return (
    <div>
      <div
        onClick={() => exit()}
        className="z-40 w-full h-full bg-gray-100 opacity-80  fixed "
        style={{
          display: transferEmailBox || success ? "" : "none",
        }}
      ></div>
      <div
        className="z-50 m-auto bg-gray-300 fixed opacity-100 top-2/4 left-2/4 p-3 pb-1  sm:border-solid sm:border-black sm:border-4"
        style={{
          transform: "translate(-50%, -50%)",
          width: window.innerWidth < 640 ? "100%" : "500px",
          display: transferEmailBox || success ? "" : "none",
        }}
      >
        <div
          style={{ display: transferEmailBox ? "" : "none" }}
          className="shadow-lg"
        >
          <div className="p-2 bg-orange-light border border-black border-4 text-lg">
            Transfer Registrations
          </div>
          <div className="bg-gray-100 p-2">
            <div className="text-red-500" id="transferError"></div>
            <div>Transfer From This Address:</div>
            <div>
              <label
                htmlFor="email"
                className="block text-sm font-medium text-gray-700"
              >
                Email Address
              </label>
              <div className="mt-1">
                <input
                  type="text"
                  name="email"
                  id="email"
                  onChange={(e) => setFromEmail(e.target.value)}
                  value={fromEmail}
                  className="shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full sm:text-sm border-gray-300 rounded-md"
                  placeholder="you@example.com"
                />
              </div>
            </div>
            <div className="pb-2">
              <label
                htmlFor="email"
                className="block text-sm font-medium text-gray-700"
              >
                Confirm Email Address
              </label>
              <div className="mt-1">
                <input
                  type="text"
                  name="email"
                  id="email"
                  value={confirmFromEmail}
                  onChange={(e) => setConfirmFromEmail(e.target.value)}
                  className="shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full sm:text-sm border-gray-300 rounded-md"
                  placeholder="you@example.com"
                />
              </div>
            </div>
            <div>Transfer To This Address:</div>
            <div>
              <label
                htmlFor="email"
                className="block text-sm font-medium text-gray-700"
              >
                Email Address
              </label>
              <div className="mt-1">
                <input
                  type="text"
                  name="email"
                  id="email"
                  onChange={(e) => setToEmail(e.target.value)}
                  value={toEmail}
                  className="shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full sm:text-sm border-gray-300 rounded-md"
                  placeholder="you@example.com"
                />
              </div>
            </div>
            <div>
              <label
                htmlFor="email"
                className="block text-sm font-medium text-gray-700"
              >
                Confirm Email Address
              </label>
              <div className="mt-1">
                <input
                  type="text"
                  name="email"
                  id="email"
                  value={confirmToEmail}
                  onChange={(e) => setConfirmToEmail(e.target.value)}
                  className="shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full sm:text-sm border-gray-300 rounded-md"
                  placeholder="you@example.com"
                />
              </div>
            </div>
            <div>
              <button
                onClick={() => register()}
                className="p-2 mt-2 bg-blue-dark text-white rounded-md"
              >
                Register
              </button>
              <button
                className="p-2 mt-2 ml-2 bg-red-500 text-white rounded-md"
                onClick={() => {
                  exit();
                }}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
        <div style={{ display: success ? "" : "none" }}>
          Your Request for a Transfer of Custodian Of Evidence (COE)
          Registrations pursuant to S.C. Code §17-28-330(A) has been received
          and should be processed shortly. Please check your supplied email
          address for a confirmation link.
        </div>
        <div className="float-right mt-2">
          <button onClick={exit}>
            <XIcon className="w-8" />
          </button>
        </div>
        Copyright © 2021 SCDC
      </div>
    </div>
  );
}
